export default function (doc) {
    const pressedKeys = {};

    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('keyup', onKeyUp);

    return {
        isPressed: isPressed,
        handlePrintOrExport: handlePrintOrExport,
    };

    function onKeyDown(event) {
        pressedKeys[event.key] = true;
    }

    function onKeyUp(event) {
        delete pressedKeys[event.key];
    }

    function isPressed(key) {
        return pressedKeys[key] || false;
    }

    function handlePrintOrExport(printFn, exportUrl) {
        if (isPressed('Shift')) {
            return window.open(exportUrl);
        }
        return printFn();
    }
}
